<template>
    <div class="user-device-list">
        <div class="slab-mobile--grand--bottom user-device-list__active" v-if="activeDevice">
            <div class="h3 slab-mobile--tiny--bottom brick-zero--left brick-zero--right">
                {{ $t('devices.this_device') }}
            </div>
            <div class="table-wrapper brick-wide--left brick-wide--right">
                <table class="table table--striped">
                    <thead>
                        <tr>
                            <th width="5%">{{ $t('devices.type') }}</th>
                            <th width="20%">{{ $t('devices.devicename') }}</th>
                            <th width="40%">{{ $t('devices.identifier') }}</th>
                            <th width="10%">{{ $t('devices.lastActivity') }}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>
                                <div class="table__type-icon">
                                    <i
                                        class="icon icon--computer"
                                        v-if="activeDevice.platform === 'web'"
                                    ></i>
                                    <i class="icon icon--phone" v-else></i>
                                </div>
                            </td>
                            <td>{{ activeDevice.name }}</td>
                            <td>{{ activeDevice.model }}, {{ activeDevice.identifier }}</td>
                            <td>
                                {{ formatDate(activeDevice.current_sign_in_at, 'Y-m-d H:i:s') }}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <div class="user-device-list__other" v-if="sortedDevices && sortedDevices.length > 0">
            <div
                class="h3 slab-mobile--tiny--bottom brick-zero--left brick-zero--right"
                v-if="activeDevice"
            >
                {{ $t('devices.other_devices') }}
            </div>
            <div class="table-wrapper brick-wide--left brick-wide--right">
                <table class="table table--striped">
                    <thead>
                        <tr>
                            <th width="5%">{{ $t('devices.type') }}</th>
                            <th width="20%">{{ $t('devices.devicename') }}</th>
                            <th width="40%">{{ $t('devices.identifier') }}</th>
                            <th width="10%">{{ $t('devices.lastActivity') }}</th>
                            <th width="5%"></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="device in sortedDevices" :key="device.id">
                            <td>
                                <div class="table__type-icon">
                                    <i
                                        class="icon icon--computer"
                                        v-if="device.platform === 'web'"
                                    ></i>
                                    <i class="icon icon--phone" v-else></i>
                                </div>
                            </td>
                            <td>{{ device.name }}</td>
                            <td>{{ device.model }}, {{ device.identifier }}</td>
                            <td>{{ formatDate(device.current_sign_in_at, 'Y-m-d H:i:s') }}</td>
                            <td>
                                <a
                                    class="button button--attention"
                                    v-if="device.identifier !== localUuid"
                                    @click="removeClickHandler(device.id)"
                                >
                                    <i class="icon icon--action-decline"></i>
                                    <span>{{ $t('devices.logout') }}</span>
                                </a>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>

<script>
import * as api from '@/api';
import formatDate from '@/mixins/formatDate';

export default {
    mixins: [formatDate],
    props: {
        userId: {
            type: [Boolean, String],
            default: false,
        },
    },
    data() {
        return {
            devices: [],
            localUuid: false,
        };
    },
    computed: {
        sortedDevices() {
            if (this.devices.length === 0) return false;
            const sortedDevices = [...this.devices].sort(function(a, b) {
                return new Date(b.current_sign_in_at) - new Date(a.current_sign_in_at);
            });
            return sortedDevices.filter(device => device.identifier !== this.localUuid);
        },
        activeDevice() {
            return this.devices.find(device => device.identifier === this.localUuid);
        },
    },
    mounted() {
        this.getUserDevices();
        this.localUuid = localStorage.getItem('uuid') || false;
    },
    methods: {
        async getUserDevices() {
            try {
                let response;
                if (this.userId) {
                    response = await api.users.getUserDevices(this.userId);
                } else {
                    response = await api.users.getDevices();
                }
                if (response) {
                    this.devices = response.data.devices;
                }
            } catch (error) {
                console.error(error);
            }
        },
        async removeUserDevice(deviceId) {
            try {
                let response;
                if (this.userId) {
                    response = await api.users.removeUserDevice(this.userId, deviceId);
                } else {
                    response = await api.users.removeDevice(deviceId);
                }
                if (response) {
                    this.getUserDevices();
                }
            } catch (error) {
                console.error(error);
                this.getUserDevices();
            }
        },
        removeClickHandler(deviceId) {
            this.$modal.show(
                () => import('@/views/modal/ConfirmDeletion.vue'),
                {
                    text: this.$t('devices.remove_device'),
                    cancelText: this.$t('buttons.cancel'),
                    confirmText: this.$t('devices.logout'),
                    successCallback: () => {
                        this.removeUserDevice(deviceId);
                    },
                },
                {
                    name: 'ConfirmDeletion',
                    scrollable: true,
                    width: 450,
                    height: 'auto',
                    class: 'ngdialog-theme-winconnect',
                }
            );
        },
    },
};
</script>
